export const pageSize = 20;
export const scansPageSize = 50;
